import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BreadcrumbTitleEnum } from '../../objects/breadcrumb/breadcrumb-title.enum';
import { Breadcrumb } from '../../objects/breadcrumb/breadcrumb.model';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.css'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {
  @Input() isMobile = false;
  @Input() public homeRoute = '#';
  @Input() breadcrumbs: Breadcrumb[] = [];
  @Output() navigateBackEvent = new EventEmitter<boolean>();
  @Output() routeToEvent = new EventEmitter<string>();
  BreadcrumbTitleEnum = BreadcrumbTitleEnum;
  constructor() {}

  ngOnInit(): void {}

  public navigateBack() {
    this.navigateBackEvent.emit(true);
  }

  public routeTo(route: string): void {
    this.routeToEvent.emit(route);
  }
}
